import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';

import {SEMIBOLD_DETAIL_TEXT} from 'analyses/alignment/modals/StyleConstants';

/**
 * A snipped of text telling the user to review assembly setup parameters.
 * @constructor
 */
export function ReviewParametersText(): JSX.Element {
  return <div className={css(styles.headerText)}>Review the following parameters.</div>;
}

const styles = StyleSheet.create({
  headerText: SEMIBOLD_DETAIL_TEXT,
});
